// This file was auto-generated by Fern from our API Definition.
export const QueryEvaluatorVariantsRequestOrder = {
    Ascending: "ascending",
    Descending: "descending",
};
